import React from 'react'
import Grid from 'components/grid.js'
import Card from 'components/card'
import Button from 'components/button.js'

export default function Listing(props) {
    const {
        items,
        columns = 3,
        className,
        style,
    } = props

    return (
        <Grid
            columns={columns}
            className={className}
            style={style}
        >
            {items.map(item => {
                const { id, url } = item
                
                return(
                    <Card
                        // debug
                        {...item}
                        key={id}
                        url={url}
                        imgSize='lg'
                        titleClassName='lg'
                        descriptionClassName='clamp-2'
                    >
                        <Button />
                    </Card>
                )
            })}
        </Grid>
    )
}
